import { Typography } from '@mui/material';

import { useTranslation } from 'modules/i18n/hooks/useTranslation';

import { Buttons } from './components/Buttons';
import { FailedBanner } from '../FailedBanner';
import {
  IReferralFlowDialogProps,
  ReferralFlowDialog,
} from '../ReferralFlowDialog';
import { ineligibleAccountDialogTranslation } from './translation';
import { useIneligibleAccountDialogStyles } from './useIneligibleAccountDialogStyles';

export interface IIneligibleAccountDialogProps
  extends IReferralFlowDialogProps {
  isSigningOut: boolean;
  onSignInButtonClick: () => void;
  referralProgramName: string | undefined;
}

export const IneligibleAccountDialog = ({
  isSigningOut,
  onSignInButtonClick,
  referralProgramName,
  ...dialogProps
}: IIneligibleAccountDialogProps) => {
  const { onClose } = dialogProps;

  const {
    keys: { branded, unbranded },
    t,
  } = useTranslation(ineligibleAccountDialogTranslation);

  const keys = referralProgramName ? branded : unbranded;

  const { classes } = useIneligibleAccountDialogStyles();

  return (
    <ReferralFlowDialog {...dialogProps} title={<FailedBanner />}>
      <div className={classes.content}>
        <Typography variant="h6">{t(keys.title)}</Typography>
        <Typography variant="body2">{t(keys.description)}</Typography>
      </div>
      <Buttons
        isSignInButtonLoading={isSigningOut}
        onCancelButtonClick={onClose}
        onSignInButtonClick={onSignInButtonClick}
      />
    </ReferralFlowDialog>
  );
};
